import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { currentContactUuid } from '../partners/current-contact-uuid';
import { staffingCalendarAccessList } from './staffing-calendar-access-list';

export const currentUserHasStaffingCalendarAccess = createSelector(
  currentEmployeeUuid,
  currentContactUuid,
  staffingCalendarAccessList,
  function (currentEmployeeUuid, currentContactUuid, accessList) {
    const userUuid = currentEmployeeUuid ?? currentContactUuid;
    if (userUuid === undefined) return false;
    return accessList.includes(userUuid);
  },
);
